<!-- Organisation mark. The step title/description are rendered by the
     register-flow shell, so this step only carries the brand + process cards. -->
<div class="text-center mb-8">
  <div
    class="w-24 h-24 mx-auto mb-5 rounded-full border-[3px] border-[#0A3D2F]/15 overflow-hidden bg-white flex items-center justify-center shadow-lg"
  >
    <img
      src="/assets/icon/ancLogo.jpeg"
      alt="ANC Logo"
      class="w-full h-full object-cover"
      onerror="this.style.opacity = '0.2'"
    />
  </div>

  <h3 class="text-xl sm:text-2xl font-bold text-deep-green mb-2">Create Your Account</h3>
  <p class="text-sm text-muted-foreground max-w-md mx-auto">
    Begin your membership journey with All Nigeria Community Ghana. Follow the three stages below to
    complete your registration.
  </p>
</div>

<!-- Process description cards -->
<div class="space-y-4 max-w-lg mx-auto mb-10">
  @for (process of processes; track $index; let i = $index) {
    <hlm-item
      variant="outline"
      class="rounded-xl border-border/70 bg-slate-50/70 transition-all duration-300 hover:border-primary/30 hover:bg-primary/[0.03] hover:shadow-sm"
    >
      <hlm-item-media variant="icon" class="bg-primary/10 text-primary rounded-xl">
        <ng-icon [name]="process.icon" />
      </hlm-item-media>
      <hlm-item-content>
        <hlm-item-title class="flex items-center gap-2">
          <span
            class="inline-flex items-center justify-center size-5 rounded-full bg-deep-green text-white text-[10px] font-bold shrink-0"
          >
            {{ i + 1 }}
          </span>
          {{ process.title }}
        </hlm-item-title>
        <p hlmItemDescription>{{ process.description }}</p>
      </hlm-item-content>
    </hlm-item>
  }
</div>

<!-- Navigation button -->
<div class="flex justify-center">
  <button
    hlmBtn
    type="button"
    (click)="continue()"
    class="inline-flex items-center gap-2 px-8 py-3.5 rounded-xl font-bold text-sm transition-all duration-300 shadow-md hover:shadow-lg hover:-translate-y-0.5 active:translate-y-0"
  >
    Continue to Form
    <ng-icon name="matArrowForwardOutline" />
  </button>
</div>

<div
  class="mt-8 pt-5 border-t border-border/60 flex items-center justify-center gap-1.5 text-xs sm:text-sm text-muted-foreground"
>
  <span>Already submitted?</span>
  <a
    routerLink="/login"
    class="font-bold text-deep-green hover:text-gold underline underline-offset-2 transition-colors"
  >
    Track Application Status
  </a>
</div>
